/**
 * Klaviyo Back in Stock - "Notify Me" integration for sold-out sizes.
 *
 * This theme does not use Klaviyo's automatic sold-out button detection,
 * so this file manages a custom "Notify Me When Available" button that
 * appears only when the selected size/variant is sold out, and submits
 * the shopper's email directly to Klaviyo's Back in Stock API.
 */
(function () {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'KLmpZF';
  var KLAVIYO_REVISION = '2024-06-15';

  // Add a little breathing room above the Notify Me button so it doesn't
  // sit flush against whatever button is above it (e.g. Add to Wishlist,
  // which some themes/apps reposition directly under the Add to Cart button).
  var baseStyle = document.createElement('style');
  baseStyle.textContent = '.notify-me-btn{margin-top:10px;}';
  document.head.appendChild(baseStyle);

  function getScope(form) {
    // The variant JSON blob and the size/variant radio buttons are rendered
    // as siblings of the <form>, not inside it - both live inside the
    // shared ".product-single__meta" wrapper for the product.
    return form.closest('.product-single__meta') || form.parentElement || form;
  }

  function getVariantsData(form) {
    var el = getScope(form).querySelector('[data-variant-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptionValues(form) {
    var values = [];
    var fieldsets = getScope(form).querySelectorAll('.variant-input-wrap');
    fieldsets.forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) {
        values.push(checked.value);
      }
    });
    return values;
  }

  function findMatchingVariant(variants, selectedValues) {
    if (!selectedValues.length) return null;
    return variants.filter(function (v) {
      return [v.option1, v.option2, v.option3].every(function (opt, i) {
        return selectedValues[i] === undefined || opt === selectedValues[i];
      });
    })[0];
  }

  function syncButtons(form) {
    var variants = getVariantsData(form);
    if (!variants.length) return;

    var selectedValues = getSelectedOptionValues(form);
    var variant = findMatchingVariant(variants, selectedValues) || variants[0];
    if (!variant) return;

    var addBtn = form.querySelector('[data-add-to-cart]');
    var notifyBtn = form.querySelector('[data-notify-back-in-stock]');
    if (!addBtn || !notifyBtn) return;

    notifyBtn.setAttribute('data-variant-id', variant.id);

    if (variant.available) {
      addBtn.style.display = '';
      addBtn.removeAttribute('disabled');
      notifyBtn.style.display = 'none';
    } else {
      addBtn.style.display = 'none';
      addBtn.setAttribute('disabled', 'disabled');
      notifyBtn.style.display = '';
    }
  }

  function initForm(form) {
    if (form.dataset.klBisBound) return;
    form.dataset.klBisBound = 'true';
    syncButtons(form);

    // The size/variant radio inputs live outside the <form> (as siblings
    // within the shared product wrapper), so listen on that wrapper -
    // a 'change' on the radios would never bubble up into the form itself.
    var scope = getScope(form);
    scope.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type="radio"][data-variant-input]') ||
        e.target.matches('select[data-product-select]')
      ) {
        setTimeout(function () {
          syncButtons(form);
        }, 0);
      }
    });
  }

  function initAllForms(root) {
    (root || document).querySelectorAll('.product-single__form').forEach(initForm);
  }

  /* ---------------- Modal ---------------- */

  var modalEl = null;

  function ensureModal() {
    if (modalEl) return modalEl;

    var wrap = document.createElement('div');
    wrap.className = 'kl-bis-modal';
    wrap.innerHTML =
      '<div class="kl-bis-modal__overlay" data-kl-bis-close></div>' +
      '<div class="kl-bis-modal__dialog" role="dialog" aria-modal="true" aria-label="Notify me when available">' +
      '  <button type="button" class="kl-bis-modal__close" data-kl-bis-close aria-label="Close">&times;</button>' +
      '  <div class="kl-bis-modal__body">' +
      '    <p class="kl-bis-modal__title">Notify Me When Available</p>' +
      '    <p class="kl-bis-modal__subtitle">Enter your email and we\'ll let you know as soon as this size is back in stock.</p>' +
      '    <form class="kl-bis-modal__form" data-kl-bis-form>' +
      '      <input type="email" required placeholder="Email address" class="kl-bis-modal__input" data-kl-bis-email />' +
      '      <button type="submit" class="btn btn--full kl-bis-modal__submit" data-kl-bis-submit>Notify Me</button>' +
      '    </form>' +
      '    <p class="kl-bis-modal__message" data-kl-bis-message></p>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(wrap);

    var style = document.createElement('style');
    style.textContent =
      '.kl-bis-modal{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;}' +
      '.kl-bis-modal.is-open{display:flex;}' +
      '.kl-bis-modal__overlay{position:absolute;inset:0;background:rgba(0,0,0,0.5);}' +
      '.kl-bis-modal__dialog{position:relative;background:#fff;max-width:400px;width:90%;padding:36px 30px;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,0.15);}' +
      '.kl-bis-modal__close{position:absolute;top:10px;right:14px;background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:#333;}' +
      '.kl-bis-modal__title{font-size:16px;letter-spacing:0.05em;text-transform:uppercase;margin:0 0 10px;}' +
      '.kl-bis-modal__subtitle{font-size:14px;color:#666;margin:0 0 20px;}' +
      '.kl-bis-modal__form{display:flex;flex-direction:column;gap:12px;}' +
      '.kl-bis-modal__input{padding:12px 14px;border:1px solid #ccc;font-size:14px;width:100%;box-sizing:border-box;}' +
      '.kl-bis-modal__message{font-size:13px;margin:14px 0 0;min-height:16px;}' +
      '.kl-bis-modal__message.is-error{color:#c0392b;}' +
      '.kl-bis-modal__message.is-success{color:#2f6f3e;}';
    document.head.appendChild(style);

    wrap.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-kl-bis-close')) {
        closeModal();
      }
    });

    var form = wrap.querySelector('[data-kl-bis-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleSubmit(wrap);
    });

    modalEl = wrap;
    return wrap;
  }

  function openModal(variantId) {
    var wrap = ensureModal();
    wrap.setAttribute('data-variant-id', variantId);
    wrap.querySelector('[data-kl-bis-message]').textContent = '';
    wrap.querySelector('[data-kl-bis-message]').className = 'kl-bis-modal__message';
    wrap.querySelector('[data-kl-bis-form]').style.display = '';
    wrap.querySelector('[data-kl-bis-email]').value = '';
    wrap.classList.add('is-open');
  }

  function closeModal() {
    if (modalEl) modalEl.classList.remove('is-open');
  }

  function handleSubmit(wrap) {
    var variantId = wrap.getAttribute('data-variant-id');
    var emailInput = wrap.querySelector('[data-kl-bis-email]');
    var submitBtn = wrap.querySelector('[data-kl-bis-submit]');
    var messageEl = wrap.querySelector('[data-kl-bis-message]');
    var email = emailInput.value.trim();

    if (!email || !variantId) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok) {
          messageEl.textContent = "You're on the list! We'll email you when this size is back in stock.";
          messageEl.className = 'kl-bis-modal__message is-success';
          wrap.querySelector('[data-kl-bis-form]').style.display = 'none';
          setTimeout(closeModal, 3500);
        } else {
          messageEl.textContent = 'Something went wrong. Please try again.';
          messageEl.className = 'kl-bis-modal__message is-error';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify Me';
        }
      })
      .catch(function () {
        messageEl.textContent = 'Something went wrong. Please try again.';
        messageEl.className = 'kl-bis-modal__message is-error';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify Me';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-notify-back-in-stock]');
    if (!btn) return;
    e.preventDefault();
    openModal(btn.getAttribute('data-variant-id'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllForms(document);
    });
  } else {
    initAllForms(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.product-single__form')) {
          initForm(node);
        } else if (node.querySelectorAll) {
          initAllForms(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
